import { AxiosError } from 'axios';
import { useMutation, useQueryClient } from 'react-query';
import { EXPRESS_API } from '../../configs/api/expressApi';
import { errorToast } from '../../toasts/error';
import { GenerateTextParams } from '../types';

interface IResponse {
  generatedPrompt: string;
  generatedText: string;
}

const generateText = async (body: GenerateTextParams) => {
  const { data } = await EXPRESS_API.post(`gpt`, body);
  return data as IResponse;
};

export const useGenerateText = () => {
  const queryClient = useQueryClient();

  return useMutation((data: GenerateTextParams) => generateText(data), {
    onError: (e: AxiosError) => {
      queryClient.invalidateQueries(['MAGIC_COUNT']);
      errorToast({
        title: e.message || 'Something went wrong generating text',
      });
    },
    onSuccess: () => queryClient.invalidateQueries(['MAGIC_COUNT']),
  });
};
